import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "src/app/shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../secure-zone-api-endpoints"

@Injectable({
  providedIn: "root",
})
export class SecureZoneDashboardService {
  private readonly securezonedashboardUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}
  
  getSZDashboardData(): Observable<any> {
    return this.http
      .post<any>(
        `${this.securezonedashboardUrl}${API_ENDPOINTS.DASHBOARD.FETCH}`,
        { }
      )
      .pipe(
        map((response) => response),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

}
